import { FCWithChildren } from '@types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  GuestButtons,
  GuestDeviceConfirm,
  GuestIdentifiedPopup,
  Modal,
  ModalBody,
} from '@components';
import useLayoutContext from '@hooks/useLayoutContext';
import { getDeviceStatus } from 'sdk-apogee';
import { getSubdomain } from '@utils';
import usePageTitle from '@hooks/usePageTitle';
import { deviceProps } from '@components/GuestDeviceConfirm/GuestDeviceConfirm';

type DeviceConflictModalProps = {
  closeModal: () => void;
  isOpen: boolean;
  isAutoDetect?: boolean;
  isAutoDetectSignedIn?: boolean;
};

const GuestsAndVisitors: FCWithChildren<DeviceConflictModalProps> = () => {
  usePageTitle('Guest Account');
  const history = useHistory();
  const SUBDOMAIN = getSubdomain();
  const { startHereSsid = null, testCaptiveMac = null } = useLayoutContext();
  const [deviceStatus, setDeviceStatus] = useState<deviceProps>();

  useEffect(() => {
    if (testCaptiveMac) {
      getDeviceStatus({
        domain: SUBDOMAIN,
        macAddress: testCaptiveMac || '',
      }).then((res) => {
        setDeviceStatus(res);
      });
    }
  }, []);

  const closeModal = () => {
    return history.push('/');
  };

  const GuestBandWidthPopup = () => (
    <ModalBody>
      <div className="mb-2 text-center">
        <h2 style={{ fontSize: '125%' }} className="pb-5">
          Guest access is limited duration and limited bandwidth.
        </h2>
      </div>
      <div className="mb-12 text-center">
        If you are a Resident or Staff user, please go back and create an account or sign&nbsp;in.
      </div>
      <GuestButtons />
    </ModalBody>
  );

  return (
    <Modal closeModal={closeModal} isOpen={true}>
      {!testCaptiveMac ? (
        <GuestIdentifiedPopup startHereSsid={startHereSsid} />
      ) : deviceStatus?.userType === 'guest' ? (
        <GuestDeviceConfirm deviceStatus={deviceStatus} />
      ) : (
        <GuestBandWidthPopup />
      )}
    </Modal>
  );
};

export default GuestsAndVisitors;
